// for now there is no standard button once done the  colors should come from the theme

// const state = JSON.parse(localStorage.getItem("global_store") || "")
// const primaryColor = state.state.theme.button.primary.background;

const primaryColor = "#00A5FF";

export const ButtonStyles = {
  // style object for base or default style
  baseStyle: {
    outline: "none",
    _focus: { boxShadow: "none" },
  },
  // styles for different sizes ("sm", "md", "lg")
  sizes: {},
  // styles for different visual variants ("outline", "solid")
  variants: {
    primary: () => ({
      // bg: "red",
      bg: primaryColor,
      borderRadius: "6px",
      fontSize: "16px",
      fontWeight: "600",
      color: "#fff",
      _hover: {
        bg: "blue.600",
        boxShadow: "md",
        color: "#fff",
        _disabled: {
          bg: primaryColor,
          color: "white",
        },
      },
    }),
    secondary: () => ({
      bg: "#EEEEEE",
      borderRadius: "4px",
      fontSize: "14px",
      fontWeight: "500",
      _hover: {
        bg: "#E5EBF5",
        boxShadow: "md",
        outline: "none",
      },
    }),
    secondaryOutline: () => ({
      bg: "#3E3E3E",
      border: "1px solid",
      borderRadius: "4px",
      transition: "all 200ms ease",
      color: "#ffffff",
      _hover: {
        bg: "transparent",
        color: "#000000",

        boxShadow: "md",
        transform: "scale(1.02)",
      },
      _focus: {
        outline: "none",
      },
    }),
  },
  // default values for `size` and `variant`
  defaultProps: {
    variant: "primary",
  },
};
